module.exports = __webpack_public_path__ + "img/xiaohui6.f4298563.jpg";